import React, { Component } from 'react'
import Header from './components/Header'
import Project from './components/Project'
import Timeline from './components/Timeline'
import Whatwedolist from './components/Whatwedolist'
import Boards from './components/Boards'
import Wish from './components/Wish'
import Footer from './components/Footer'

class App extends Component {

  render() {
    return (
    	<div>
			<Header />
			<Wish />
			<Project />
			<Timeline />
			<Whatwedolist />
			<Boards />
			<Footer />
	    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js